/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import DeleteAction from './DeleteAction/index'
import Edit from './Edit/index'
import PreviewImage from 'DesignSystem/PreviewImage/index'
import React from 'react'
import SendSecurely from './SendSecurely/index'
import ThreeDotsMenu from 'DesignSystem/ThreeDotsMenu/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/Images/Content/Images/AllImages/Content/PatientImage/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let resourceObjectMetaUrlValueData = fromData.useDataValue({ viewPath,
context: 'resource_object_meta',
path: 'url',
})
let onClick = fromHelpers.useOnOpenGallery({
  children,
  viewPath
  
})
let patientImageSlotKeyValueData = fromData.useDataFormat({ viewPath,
context: 'patient_image',
path: 'slot_key',
format: fromFormat.getPatientImageName,
})
let imageActionsValueData = fromData.useDataValue({ viewPath,
context: 'image_actions',
})
let patientImageIdValueData = fromData.useDataValue({ viewPath,
context: 'patient_image',
path: 'id',
})
let appPropertiesAudaxCephEnabledValueData = fromData.useDataValue({ viewPath,
context: 'app_properties',
path: 'audax_ceph_enabled',
})
let aggregateData = fromHelpers.getThreeDotsMenu(imageActionsValueData, patientImageIdValueData, appPropertiesAudaxCephEnabledValueData)
let onClick1 = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-5-Z1Yf8zk': dtColorsNeutral400,'--bc-6-Z1Yf8zk': dtColorsWhite,'--btlr-7-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-8-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-9-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-10-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--ml-11-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mr-12-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mt-13-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mb-14-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<PreviewImage
  viewPath={`${viewPath}/PreviewImage`}
 data="resource_object_meta.url"
 url={resourceObjectMetaUrlValueData}
 onClick={onClick}
 width={200}
 height={200}
 cursor="pointer"
/>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="patient_image.slot_key"
 format="/Data/format.js getPatientImageName"
 text={patientImageSlotKeyValueData}
 lineHeight={1}
 overflow="hidden"
 textOverflow="ellipses"
 maxWidth={200}
/>
<ThreeDotsMenu
  viewPath={`${viewPath}/ThreeDotsMenu`}
 data="image_actions"
 data="patient_image.id"
 data="app_properties.audax_ceph_enabled"
 aggregate="helpers.js getThreeDotsMenu"
 from={aggregateData}
 onClick={onClick1}
/>
</div>
</div>
<Edit
  viewPath={`${viewPath}/Edit`}
/>
<DeleteAction
  viewPath={`${viewPath}/DeleteAction`}
/>
<SendSecurely
  viewPath={`${viewPath}/SendSecurely`}
/>
{children}
</React.Fragment>)
}